/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {NewsletterUpdateResult} from '../models/NewsletterUpdateResult';
import type {UpdateUserNewsletter} from '../models/UpdateUserNewsletter';

export interface GetNewsletterBulkUpdateResult$Request {
    id: string;
}

export interface GetNewsletterBulkUpdateResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getNewsletterBulkUpdateResultRequest = createAction<PayloadData<void, GetNewsletterBulkUpdateResult$Request>>('USER_NEWSLETTER_BULK_UPDATE__GET_NEWSLETTER_BULK_UPDATE_RESULT__REQUEST');
export const getNewsletterBulkUpdateResultSuccess = createAction<PayloadData<NewsletterUpdateResult, GetNewsletterBulkUpdateResult$Request>>('USER_NEWSLETTER_BULK_UPDATE__GET_NEWSLETTER_BULK_UPDATE_RESULT__SUCCESS');
export const getNewsletterBulkUpdateResultFailure = createAction<PayloadData<Error, GetNewsletterBulkUpdateResult$Request, true>>('USER_NEWSLETTER_BULK_UPDATE__GET_NEWSLETTER_BULK_UPDATE_RESULT__FAILURE');

export const getNewsletterBulkUpdateResultActions = [
    getNewsletterBulkUpdateResultRequest,
    getNewsletterBulkUpdateResultSuccess,
    getNewsletterBulkUpdateResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getNewsletterBulkUpdateResult = (meta: GetNewsletterBulkUpdateResult$Request, config?: GetNewsletterBulkUpdateResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getNewsletterBulkUpdateResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/newsletters`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetNewsletterUpdateProgress$Request {
    id: string;
}

export interface GetNewsletterUpdateProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getNewsletterUpdateProgressRequest = createAction<PayloadData<void, GetNewsletterUpdateProgress$Request>>('USER_NEWSLETTER_BULK_UPDATE__GET_NEWSLETTER_UPDATE_PROGRESS__REQUEST');
export const getNewsletterUpdateProgressSuccess = createAction<PayloadData<BulkProgress, GetNewsletterUpdateProgress$Request>>('USER_NEWSLETTER_BULK_UPDATE__GET_NEWSLETTER_UPDATE_PROGRESS__SUCCESS');
export const getNewsletterUpdateProgressFailure = createAction<PayloadData<Error, GetNewsletterUpdateProgress$Request, true>>('USER_NEWSLETTER_BULK_UPDATE__GET_NEWSLETTER_UPDATE_PROGRESS__FAILURE');

export const getNewsletterUpdateProgressActions = [
    getNewsletterUpdateProgressRequest,
    getNewsletterUpdateProgressSuccess,
    getNewsletterUpdateProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getNewsletterUpdateProgress = (meta: GetNewsletterUpdateProgress$Request, config?: GetNewsletterUpdateProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getNewsletterUpdateProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/newsletters/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopNewsletterBulkUpdate$Request {
    id: string;
}

export interface StopNewsletterBulkUpdate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopNewsletterBulkUpdateRequest = createAction<PayloadData<void, StopNewsletterBulkUpdate$Request>>('USER_NEWSLETTER_BULK_UPDATE__STOP_NEWSLETTER_BULK_UPDATE__REQUEST');
export const stopNewsletterBulkUpdateSuccess = createAction<PayloadData<void, StopNewsletterBulkUpdate$Request>>('USER_NEWSLETTER_BULK_UPDATE__STOP_NEWSLETTER_BULK_UPDATE__SUCCESS');
export const stopNewsletterBulkUpdateFailure = createAction<PayloadData<Error, StopNewsletterBulkUpdate$Request, true>>('USER_NEWSLETTER_BULK_UPDATE__STOP_NEWSLETTER_BULK_UPDATE__FAILURE');

export const stopNewsletterBulkUpdateActions = [
    stopNewsletterBulkUpdateRequest,
    stopNewsletterBulkUpdateSuccess,
    stopNewsletterBulkUpdateFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopNewsletterBulkUpdate = (meta: StopNewsletterBulkUpdate$Request, config?: StopNewsletterBulkUpdate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopNewsletterBulkUpdateActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/newsletters`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UsersNewsletterBulkUpdate$Request {
    updateUserNewsletter: UpdateUserNewsletter;
    reason?: string;
}

export interface UsersNewsletterBulkUpdate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const usersNewsletterBulkUpdateRequest = createAction<PayloadData<void, UsersNewsletterBulkUpdate$Request>>('USER_NEWSLETTER_BULK_UPDATE__USERS_NEWSLETTER_BULK_UPDATE__REQUEST');
export const usersNewsletterBulkUpdateSuccess = createAction<PayloadData<string, UsersNewsletterBulkUpdate$Request>>('USER_NEWSLETTER_BULK_UPDATE__USERS_NEWSLETTER_BULK_UPDATE__SUCCESS');
export const usersNewsletterBulkUpdateFailure = createAction<PayloadData<Error, UsersNewsletterBulkUpdate$Request, true>>('USER_NEWSLETTER_BULK_UPDATE__USERS_NEWSLETTER_BULK_UPDATE__FAILURE');

export const usersNewsletterBulkUpdateActions = [
    usersNewsletterBulkUpdateRequest,
    usersNewsletterBulkUpdateSuccess,
    usersNewsletterBulkUpdateFailure
] as const;

/**
 * @param {UpdateUserNewsletter} meta.updateUserNewsletter
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const usersNewsletterBulkUpdate = (meta: UsersNewsletterBulkUpdate$Request, config?: UsersNewsletterBulkUpdate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: usersNewsletterBulkUpdateActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/newsletters`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateUserNewsletter,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

